import { HTMLProps } from "react";
import { useTeamScopeState } from "stores/ScopeStateStore";
import { PuzzleLink } from "components/Link";
import { Spinner } from "components/Loading";
import PuzzleContentDisplay from "components/PuzzleContent/PuzzleContentDisplay";
import "./PuzzleContentPreview.css";

export function PuzzleContentPreview(
  props: { puzName: string } & HTMLProps<HTMLDivElement>
) {
  const { puzName, ...otherProps } = props;
  return (
    <div className="puzzle-content-preview no-copy" {...otherProps}>
      <PuzzleContentDisplay puzName={puzName} isPreview={true} />
    </div>
  );
}

export function PuzzleContentPreviewWithLink({ puzName }: { puzName: string }) {
  const teamScopeState = useTeamScopeState();

  if (teamScopeState === null) return <Spinner inline />;
  const puzData = teamScopeState.puzzles[puzName];
  // Fail gracefully and clearly  since we can hit this
  // case in dev and posthunt.
  if (puzData === undefined)
    return (
      <div className="puzzle-content-preview-with-link puzzle-content-preview-not-unlocked">
        (Puzzle not unlocked)
      </div>
    );

  return (
    <div className="puzzle-content-preview-with-link">
      <PuzzleContentPreview puzName={puzName} />
      <PuzzleLink className="puzzle-content-preview-link" puzName={puzName}>
        <div className="copy-only">[Link to another puzzle]</div>
      </PuzzleLink>
    </div>
  );
}
